import React from 'react';
import { getLanguage, setLanguage } from '../localization';

export default function LanguageSelector() {
    const language = getLanguage();
    const nextLanguage = language === 'fo' ? 'en' : 'fo';
    const label = language === 'fo' ? 'Switch to English' : 'Skift til føroyskt';
    return (
        <button
            type="button"
            className="language-button"
            aria-label={label}
            title={label}
            onClick={() => setLanguage(nextLanguage)}
            >
            <img
                src={`/images/flags/${nextLanguage === 'en' ? 'uk' : 'fo'}.svg`}
                alt=""
                width="32"
                height="24"
                style={{ display: 'block', objectFit: 'contain' }} />
        </button>
    );
}
